import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { OralDeposition } from '../../../models/oral-deposition';

import { NotyService } from '../../../services/common/noty.service';
import { OralDepositionService } from '../../../services/oral_depositions/oral-deposition.service';

declare var moment: any;
declare var swal: any;

@Component({
  selector: 'app-oral-deposition-show',
  templateUrl: './oral-deposition-show.component.html',
  styleUrls: ['./oral-deposition-show.component.scss'],
})
export class OralDepositionShowComponent implements OnInit {
  cancellingOralDeposition: boolean = false;

  cancellingEvent: boolean = false;

  deletingNote: boolean = false;

  deletingEvent: boolean = false;

  emailingNote: boolean = false;

  holdingEvent: boolean = false;

  loading: boolean = true;

  newNote: string;

  newOralDepositionEvent: any = {};

  oralDeposition: OralDeposition;

  oralDepositionId: number;

  reschedulingEvent: boolean = false;

  showNewEvent: boolean = false;

  showNewNote: boolean = false;

  savingNote: boolean = false;

  savingEvent: boolean = false;

  schedulingEvent: boolean = false;

  constructor(private notyService: NotyService, private oralDepositionService: OralDepositionService, private route: ActivatedRoute) {
    let currentTime: any = moment().add(1, 'hour').startOf('hour');
    this.newOralDepositionEvent.date = currentTime.format('MM/DD/YYYY');
    this.newOralDepositionEvent.start_time = {
      hour: Number(currentTime.format('h')),
      minute: Number(currentTime.format('m')),
      meridian: currentTime.format('A'),
    };
    currentTime = currentTime.add(1, 'hour');
    this.newOralDepositionEvent.end_time = {
      hour: Number(currentTime.format('h')),
      minute: Number(currentTime.format('m')),
      meridian: currentTime.format('A'),
    };
  }

  // Component life cycle events
  ngOnInit() {
    this.oralDepositionId = Number(this.route.snapshot.params['id']);
    this.loadOralDeposition();
  }

  // Component methods
  acceptanceChanged(oralDepositionAccept: any, oral_deposition_event_id: number) {
    oralDepositionAccept.accepted_checkbox = !oralDepositionAccept.accepted_checkbox;
    this.oralDepositionService
      .acceptanceUpdate(this.oralDeposition.id, oral_deposition_event_id, oralDepositionAccept.id, oralDepositionAccept.accepted_checkbox)
      .then((response_json) => {
        if (response_json.success) {
          oralDepositionAccept.accepted = oralDepositionAccept.accepted_checkbox;
          this.updateAllParticipantsSelected();
          this.notyService.notify(response_json.text || 'Acceptance updated', 'success');
        } else {
          oralDepositionAccept.accepted_checkbox = oralDepositionAccept.accepted;
          this.notyService.notify(response_json.text || 'Error updating acceptance', 'error');
        }
      })
      .catch(() => {
        oralDepositionAccept.accepted_checkbox = oralDepositionAccept.accepted;
        this.notyService.notify('Error updating acceptance', 'error');
      });
  }

  cancelEvent(oralDepositionEvent: any) {
    this.cancellingEvent = true;
    oralDepositionEvent.cancellingEvent = true;
    this.oralDepositionService
      .cancelHoldEvent(oralDepositionEvent.id, this.oralDeposition.id)
      .then((response_json) => {
        this.cancellingEvent = false;
        oralDepositionEvent.cancellingEvent = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Event cancelled', 'warning');
          oralDepositionEvent.event_id = null;
        } else this.notyService.notify(response_json.text || 'Error cancelling event', 'error');
      })
      .catch(() => {
        this.cancellingEvent = false;
        oralDepositionEvent.cancellingEvent = false;
        this.notyService.notify('Error cancelling event', 'error');
      });
  }

  cancelOralDeposition() {
    if (this.cancellingOralDeposition) return;
    this.cancellingOralDeposition = true;
    this.oralDepositionService
      .cancelOralDeposition(this.oralDeposition.id)
      .then((response_json) => {
        this.cancellingOralDeposition = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Oral Deposition cancelled', 'success');
          this.loadOralDeposition();
        } else this.notyService.notify(response_json.text || 'Error cancelling oral deposition', 'error');
      })
      .catch(() => {
        this.cancellingOralDeposition = false;
        this.notyService.notify('Error cancelling oral deposition', 'error');
      });
  }

  deleteNote(matterHistory: any) {
    if (this.deletingNote || this.emailingNote || this.savingNote) return;
    swal({
      title: 'Delete Note',
      text: 'Confirm Note Delete?',
      icon: 'warning',
      buttons: {
        b1: {
          text: 'Yes',
          value: 'yes',
          className: 'btn btn-danger',
        },
        b2: {
          text: 'No',
          value: 'no',
          className: 'btn btn-outline-secondary',
        },
      },
    })
      .then((value: string) => {
        switch (value) {
          case 'yes':
            this.deletingNote = true;
            this.oralDepositionService
              .deleteNote(matterHistory.id, this.oralDeposition.id)
              .then((response_json) => {
                this.deletingNote = false;
                if (response_json.success) {
                  this.notyService.notify(response_json.text || 'Note deleted', 'warning');
                  this.oralDeposition.matter_history_notes = response_json.matter_history_notes;
                } else this.notyService.notify(response_json.text || 'Error deleting note', 'error');
              })
              .catch(() => {
                this.deletingNote = false;
                this.notyService.notify('Error deleting note', 'error');
              });
            break;
          case 'no':
            //resolve();
            break;
        }
        return value;
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  deleteProposedEvent(oralDepositionEvent: any) {
    if (this.deletingNote || this.emailingNote || this.savingNote || this.deletingEvent) return;
    swal({
      title: 'Delete Event',
      text: 'Confirm Event Delete?',
      icon: 'warning',
      buttons: {
        b1: {
          text: 'Yes',
          value: 'yes',
          className: 'btn btn-danger',
        },
        b2: {
          text: 'No',
          value: 'no',
          className: 'btn btn-outline-secondary',
        },
      },
    })
      .then((value: string) => {
        switch (value) {
          case 'yes':
            this.deletingEvent = true;
            this.oralDepositionService
              .deleteEvent(oralDepositionEvent.id, this.oralDeposition.id)
              .then((response_json) => {
                this.deletingNote = false;
                if (response_json.success) {
                  this.notyService.notify(response_json.text || 'Event deleted', 'warning');
                  this.oralDeposition.oral_deposition_events = response_json.oral_deposition_events;
                } else this.notyService.notify(response_json.text || 'Error deleting event', 'error');
              })
              .catch(() => {
                this.deletingNote = false;
                this.notyService.notify('Error deleting event', 'error');
              });
            break;
          case 'no':
            //resolve();
            break;
        }
        return value;
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  emailNote(matterHistory: any) {
    if (this.deletingNote || this.emailingNote || this.savingNote) return;
    swal({
      title: 'Email Note',
      text: 'Email Note to Attorney?',
      icon: 'info',
      buttons: {
        b1: {
          text: 'Yes',
          value: 'yes',
          className: 'btn btn-primary',
        },
        b2: {
          text: 'No',
          value: 'no',
          className: 'btn btn-outline-secondary',
        },
      },
    })
      .then((value: any) => {
        switch (value) {
          case 'yes':
            this.emailingNote = true;
            this.oralDepositionService
              .emailNote(matterHistory.id, this.oralDeposition.id)
              .then((response_json) => {
                this.emailingNote = false;
                if (response_json.success) this.notyService.notify(response_json.text || 'Note emailed', 'success');
                else this.notyService.notify(response_json.text || 'Error emailing note', 'error');
              })
              .catch(() => {
                this.emailingNote = false;
                this.notyService.notify('Error emailing note', 'error');
              });
            break;
          case 'no':
            //resolve();
            break;
        }
        return value;
      })
      .catch((err: any) => {
        console.error(err);
      });
  }

  holdEvent(oralDepositionEvent: any) {
    this.holdingEvent = true;
    oralDepositionEvent.holdingEvent = true;
    this.oralDepositionService
      .holdEvent(oralDepositionEvent.id, this.oralDeposition.id)
      .then((response_json) => {
        this.holdingEvent = false;
        oralDepositionEvent.holdingEvent = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Event created', 'success');
          oralDepositionEvent.event_id = response_json.event_id;
        } else this.notyService.notify(response_json.text || 'Error holding event', 'error');
      })
      .catch(() => {
        this.holdingEvent = false;
        oralDepositionEvent.holdingEvent = false;
        this.notyService.notify('Error holding event', 'error');
      });
  }

  loadOralDeposition() {
    this.loading = true;
    this.oralDepositionService
      .get(this.oralDepositionId)
      .then((oralDeposition) => {
        this.loading = false;
        this.oralDeposition = oralDeposition;
        for (let oralDepositionEvent of this.oralDeposition.oral_deposition_events) for (let oralDepositionAccept of oralDepositionEvent.oral_deposition_accepts) oralDepositionAccept.accepted_checkbox = oralDepositionAccept.accepted;
        this.updateAllParticipantsSelected();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  rescheduleEvent() {
    if (this.reschedulingEvent) return;
    this.reschedulingEvent = true;
    this.oralDepositionService
      .rescheduleEvent(this.oralDepositionId)
      .then((response_json) => {
        this.reschedulingEvent = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Oral Deposition Rescheduled', 'success');
          this.loadOralDeposition();
        } else this.notyService.notify(response_json.text || 'Error rescheduling oral deposition', 'error');
      })
      .catch(() => {
        this.reschedulingEvent = false;
        this.notyService.notify('Error rescheduling oral deposition', 'error');
      });
  }

  saveEvent(oralDepositionEvent: any = null) {
    if (!oralDepositionEvent) oralDepositionEvent = this.newOralDepositionEvent;
    if (!oralDepositionEvent.date || !oralDepositionEvent.start_time || !oralDepositionEvent.end_time) {
      this.notyService.notify('Please check event form, date and time needs to be entered', 'warning');
      return;
    }
    if (oralDepositionEvent.start_time.hour > 12) oralDepositionEvent.start_time.hour -= 12;
    if (oralDepositionEvent.end_time.hour > 12) oralDepositionEvent.end_time.hour -= 12;
    this.savingEvent = true;
    this.oralDepositionService
      .saveEvent(oralDepositionEvent, this.oralDeposition.id)
      .then((response_json) => {
        this.savingEvent = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Event saved', 'success');
          if (oralDepositionEvent.id) oralDepositionEvent.editing = false;
          else {
            this.showNewEvent = false;
            this.newOralDepositionEvent = {};
            let currentTime: any = moment().add(1, 'hour').startOf('hour');
            this.newOralDepositionEvent.date = currentTime.format('MM/DD/YYYY');
            this.newOralDepositionEvent.start_time = {
              hour: Number(currentTime.format('h')),
              minute: Number(currentTime.format('m')),
              meridian: currentTime.format('A'),
            };
            currentTime = currentTime.add(1, 'hour');
            this.newOralDepositionEvent.end_time = {
              hour: Number(currentTime.format('h')),
              minute: Number(currentTime.format('m')),
              meridian: currentTime.format('A'),
            };
          }
          this.oralDeposition.oral_deposition_events = response_json.oral_deposition_events;
          this.oralDeposition.status = 'checking_dates';
        } else this.notyService.notify(response_json.text || 'Error saving event', 'error');
      })
      .catch(() => {
        this.savingEvent = false;
        this.notyService.notify('Error saving event', 'error');
      });
  }

  saveNote(note: string | null = null, matter_history: any = null) {
    let matter_history_id: number | undefined = undefined;
    if (!matter_history) note = this.newNote;
    else matter_history_id = matter_history.id;
    if (!note) {
      this.notyService.notify('Please enter a note', 'warning');
      return;
    }
    this.savingNote = true;
    this.oralDepositionService
      .saveNote(note, matter_history_id, this.oralDeposition.id)
      .then((response_json) => {
        this.savingNote = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Note saved', 'success');
          if (matter_history) matter_history.editing = false;
          else {
            this.showNewNote = false;
            this.newNote = '';
          }
          this.oralDeposition.matter_history_notes = response_json.matter_history_notes;
        } else this.notyService.notify(response_json.text || 'Error saving note', 'error');
      })
      .catch(() => {
        this.savingNote = false;
        this.notyService.notify('Error saving note', 'error');
      });
  }

  scheduleEvent(oralDepositionEventId: number) {
    this.schedulingEvent = true;
    this.oralDepositionService
      .scheduleEvent(oralDepositionEventId, this.oralDepositionId)
      .then((response_json) => {
        this.schedulingEvent = false;
        if (response_json.success) {
          this.notyService.notify(response_json.text || 'Oral Deposition Scheduled', 'success');
          this.oralDeposition.status = 'scheduled';
          this.oralDeposition.editing_allowed = response_json.editing_allowed;
        } else this.notyService.notify(response_json.text || 'Error scheduling oral deposition', 'error');
      })
      .catch(() => {
        this.schedulingEvent = false;
        this.notyService.notify('Error scheduling oral deposition', 'error');
      });
  }

  updateAllParticipantsSelected() {
    for (let oralDepositionEvent of this.oralDeposition.oral_deposition_events) {
      oralDepositionEvent.all_participants_accepted = true;
      for (let oralDepositionAccept of oralDepositionEvent.oral_deposition_accepts)
        if (!oralDepositionAccept.accepted) {
          oralDepositionEvent.all_participants_accepted = false;
          break;
        }
    }
  }
}
